import { INTERVENTION_MODE } from 'constants/InterventionConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { createDictionary } from 'utils/ObjectUtils';

export const IMAGE_TYPE = 'IMAGE';
export const IMAGE_INSIDE_360 = 'IMAGE_INSIDE_360';
export const VIDEO_TYPE = 'VIDEO';
export const VIDEO_360_TYPE = 'VIDEO_360';
export const DOCUMENT_TYPE = 'DOCUMENT';
export const ALL_TYPE = 'ALL';

export const MEDIA_TYPE = {
  IMAGE: IMAGE_TYPE,
  IMAGE_INSIDE_360,
  VIDEO: VIDEO_TYPE,
  360: VIDEO_360_TYPE,
  DOCUMENT: DOCUMENT_TYPE,
  ALL: ALL_TYPE
};

const CONTENT_TYPE_TO_MEDIA_TYPE = createDictionary(
  {
    image: IMAGE_TYPE,
    video: VIDEO_TYPE
  },
  [MEDIA_TYPE.DOCUMENT]
);

// TODO: check this function...
export const contentTypeToMediaType = (contentType: any) => {
  const matchedType = Object.keys(CONTENT_TYPE_TO_MEDIA_TYPE).find((type) =>
    contentType.includes(type));

  return CONTENT_TYPE_TO_MEDIA_TYPE[matchedType as any];
};

export const LEGACY_MEDIA_TYPE = [IMAGE_TYPE, VIDEO_TYPE, DOCUMENT_TYPE];

export const ALLOWED_MEDIA_TYPES_FOR_THUMBNAIL = [IMAGE_TYPE, IMAGE_INSIDE_360, VIDEO_TYPE, VIDEO_360_TYPE];

export const USER_MAX_IMAGE_SIZE = 1;
export const DEALER_MAX_SAMPLE_MEDIA = 1;

export const MEDIA_PATH_ENUM = {
  ORIGINAL: 'ORIGINAL',
  PATH: 'PATH'
};

export const ZIP_QUALITY_ENUM = {
  ORIGINAL: 'ORIGINAL',
  COMPRESSED: 'COMPRESSED'
};

export const RATIO_16_9 = 16 / 9;

export const DEFAULT_TOLERANCE = 0.2;

export const MAX_MODEL_UPLOAD_SIZE = 10000000; // 10mb

export const TRANSFORMATION_TYPES = {
  CLIPPING: 'CLIPPING'
};

export const EXTERNAL_MEDIA_STATUS = {
  ERROR: 'ERROR',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS'
};

export const STATUS_LOADED = 'LOADED';
export const STATUS_FAILED = 'FAILED';
export const STATUS_LOADING = 'LOADING';
export const STATUS_DELETED = 'DELETED';

export const PROCESSING_STATUS = {
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED'
};

export const INTERVENTION_MEDIA_TYPE_BY_MODE = createDictionary(
  { [INTERVENTION_MODE.PARTS]: ENTITY_TYPE.PARTS_INTERVENTION },
  ENTITY_TYPE.INTERVENTION
);

export const VIDEO_CUSTOMIZATION_TYPE = {
  PRE_VIDEO: 'preVideo',
  POST_VIDEO: 'postVideo'
};

export const MAX_MEDIA_NAME_LENGTH = 100;
